module.exports = __webpack_public_path__ + "6664903856c036e008905d063cc59c1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cats/icon-fitness@2x.png
// module id = 1745
// module chunks = 0